module.exports = __webpack_public_path__ + "static/media/SchoolCosHowItWorks3.20e8599b.png";